import React from "react";
import SvgIcon from "@material-ui/core/SvgIcon";
import AssignmentIcon from "@material-ui/icons/Assignment";

function PoslovniSubjektIcon(props) {
  return <AssignmentIcon {...props}/>;
}

export default PoslovniSubjektIcon;
